import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Topbar = _resolveComponent("Topbar");
  const _component_el_header = _resolveComponent("el-header");
  const _component_el_container = _resolveComponent("el-container");
  return _openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [_createVNode(_component_el_header, {
      class: "menu",
      style: _normalizeStyle({
        '--background-color': _ctx.$store.state.BackgroundStatus.BackgroundColor
      })
    }, {
      default: _withCtx(() => [_createVNode(_component_Topbar)]),
      _: 1
    }, 8, ["style"])]),
    _: 1
  });
}